<template>
  <div class="event-card">
    <div v-if="event.event_date" class="card-date">
      <div class="month">Jan</div>
      <div class="day">25</div>
      <div class="year">2019</div>
    </div>
    <div class="top-content">
      <div class="picture">
      </div>
    </div>
    <div class="bottom-content">
      <div class="elicut card-title">
        {{ event.title }}
      </div>
      <div class="elicut card-description">
        {{ event.event_description }}
      </div>
    </div>
  </div>
</template>

<script>
import { Component, BaseComponent } from '@/libs/BaseComponent'

@Component({
  props: {
    event: {
      type: Object
    }
  }
})
export default class EventCard extends BaseComponent {}
</script>

<style lang="scss" scoped>
  .event-card {
    display: flex;
    flex-direction: column;
    margin: 10px;
    position: relative;
    height: 320px;
    border-radius: 6px;
    border: 1px solid black;
    transition: 0.25s;
    cursor: pointer;

    &:hover {
      border: 1px solid #e35268;
    }

    .card-date {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      top: -4px;
      left: 20px;
      z-index:2;
      width: 80px;
      height: 80px;
      background: rgba(0,0,0,0.7);
      border-radius: 6px;
      color: #fff;
      font-size: 14px;

      .month {
        color: #e00;
      }
      .day {
        font-size: 20px;
      }
    }

    .top-content {
      height: 200px;
      width: 320px;
      background: #222327;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px 6px 0 0;

      .picture {
        width: 300px;
        height: 180px;
        background-image: radial-gradient(circle, #fb7c0a, #f82a51);
      }
    }

    .bottom-content {
      height:120px;
      background: #4b545d;
      border-radius: 0 0 6px 6px ;

      .card-title {
        padding: 20px 10px 10px 10px;
        font-size: 18px;
        color: #f6f6f6;
      }
      .card-description {
        padding:0 10px 10px 10px;
        overflow: hidden;
        width: 320px;
        font-size: 13px;
        color: #989fa7;
        white-space: normal;
        -webkit-line-clamp: 2;
        line-height: 20px;
        max-height: calc(2 * 20px);
      }
    }
  }
</style>
